import styles from "./styles.module.css";
import { useState, useEffect } from "react";

export default function Card({ file, selected, onClick, appId }) {
  const [type, setType] = useState("");

  useEffect(() => {
    if (file.type.includes("image")) {
      return setType("Image");
    }
    if (file.type.includes("pdf")) {
      return setType("PDF");
    }
    if (file.type.includes("application")) {
      return setType("Document");
    }
    return setType("Other");
  }, [file]);

  const getUrl = () => {
    if (file.type.includes("image")) {
      return `url(${file.url})`;
    }
    if (file.type.includes("pdf")) {
      return "url(https://uploads.brevitybuilder.com/Document.png)";
    }
    if (file.type.includes("application")) {
      return setType("Document");
    }
    return setType("Other");
  };
  return (
    <div
      onClick={() => onClick(file)}
      className={selected ? `${styles.card} ${styles.selected}` : styles.card}
    >
      <div
        style={{ backgroundImage: getUrl() }}
        className={styles.cardImage}
      ></div>
      <div className={styles.cardContent}>
        <div className={styles.fileName}>{file.name}</div>
        <div className={styles.fileMeta}>{type}</div>
      </div>
    </div>
  );
}
